import { Box, Checkbox, FormControlLabel, Grid } from '@mui/material';
import React from 'react';
import Typography from '@mui/material/Typography';
import { DragIndicator } from '@mui/icons-material';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { AccountData, Language, OrderPageData } from '../api';
import { WorkshopCircle } from '../common/ui/WorkshopCircle';

interface SortableOrderPageItemProps {
  id: string;
  page: OrderPageData;
  account: AccountData;
  language: Language;
  checked: boolean;
  onToggle: (pageId: string, checked: boolean) => void;
}

export const SortableOrderPageItem: React.FC<SortableOrderPageItemProps> = ({
  id,
  page,
  account,
  language,
  checked,
  onToggle,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box
          {...listeners}
          sx={{ display: 'flex', alignItems: 'center', cursor: 'grab', '&:active': { cursor: 'grabbing' } }}>
          <DragIndicator sx={{ color: 'text.secondary', marginInlineEnd: 0.5 }} />
        </Box>
        <FormControlLabel
          control={<Checkbox checked={checked} onChange={() => onToggle(page.id, checked)} />}
          label={
            <Grid container flexWrap="nowrap" gap={1} alignContent="baseline">
              <Grid pt={0.4}>
                <WorkshopCircle account={account} orderPageId={page.id} language={language} />
              </Grid>
              <Typography>{page.label[language]}</Typography>
            </Grid>
          }
        />
      </Box>
    </div>
  );
};
